<i class="fa"
   aria-hidden="true"
   [ngClass]="{ 'fa-plus': !expanded, 'fa-minus': expanded }"></i>
